module.exports = __webpack_public_path__ + "img/button_stop.ca9557f7.svg";